import {lazy} from 'react';
import {Form} from 'semantic-ui-react';
import {convertDatetimeToObject, formatDatetimeObject} from './utils';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import './datepicker.scss';

const Calendar = lazy(function () {
  return import('react-modern-calendar-datepicker');
});

function FormDatePicker(props) {
  const {
    input: {name, value, onChange},
    required, label, placeholder,
    minimumDate, maximumDate, disabledDays, size,
    meta: {touched, error}
  } = props;
  const id = props.id || name;
  const selectedDay = value ? convertDatetimeToObject(value) : null;
  const exactLabel = ['.', '?', '!', '؟'].includes(label.charAt(label.length - 1));

  return (
    <Form.Field
      fluid
      id={id}
      label={exactLabel ? label : `${label} :`}
      required={required}
      control={Calendar}
      placeholder={placeholder}
      size={size}
      error={(touched && error != null) ? error : false}
      value={selectedDay}
      onChange={handleChange.bind(null, onChange)}
      inputPlaceholder={placeholder}
      shouldHighlightWeekends
      locale='fa'
      minimumDate={minimumDate}
      maximumDate={maximumDate}
      disabledDays={disabledDays}
    />
  );
}

function handleChange(setValue, newValue) {
  setValue(formatDatetimeObject(newValue));
}

export default FormDatePicker;
